import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "@fontsource-variable/albert-sans";
import "./index.css";
import { SITE } from "@/lib/site";

if (window.location.pathname.startsWith(SITE)) {
  const robots = document.createElement("meta");
  robots.name = "robots";
  robots.content = "noindex, nofollow";
  document.head.append(robots);
}

// Render the app
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element could not be found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
